var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBoundingBox = function SvgIconBoundingBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 5v-.5A1.75 1.75 0 0 0 7.5 2.75h-3A1.75 1.75 0 0 0 2.75 4.5v3c0 .966.784 1.75 1.75 1.75H5v5.5h-.5a1.75 1.75 0 0 0-1.75 1.75v3c0 .966.784 1.75 1.75 1.75h3a1.75 1.75 0 0 0 1.75-1.75V19h5.5v.5c0 .966.784 1.75 1.75 1.75h3a1.75 1.75 0 0 0 1.75-1.75v-3a1.75 1.75 0 0 0-1.75-1.75H19v-5.5h.5a1.75 1.75 0 0 0 1.75-1.75v-3a1.75 1.75 0 0 0-1.75-1.75h-3a1.75 1.75 0 0 0-1.75 1.75V5zm-4.5 2.25v-2.5h2.5v2.5zM9.25 7v.5A1.75 1.75 0 0 1 7.5 9.25H7v5.5h.5c.966 0 1.75.784 1.75 1.75v.5h5.5v-.5c0-.966.784-1.75 1.75-1.75h.5v-5.5h-.5a1.75 1.75 0 0 1-1.75-1.75V7zm7.5.25h2.5v-2.5h-2.5zm0 9.5h2.5v2.5h-2.5zm-9.5 0h-2.5v2.5h2.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBoundingBox;